import React from 'react';
import { RichTextContentProps } from './RichTextContent';
import { Mark } from 'types/RichTextContent';

import './Text.scss';

type TextMarkProps = {
  mark: {
    type: Mark;
  };
  children: React.ReactChild;
};

const TextMark = ({ mark, children }: TextMarkProps) => {
  switch (mark.type) {
    case 'bold':
      return <strong>{children}</strong>;
    case 'code':
      return <code>{children}</code>;
    case 'italic':
      return <em>{children}</em>;
    case 'underline':
      return <span className="rich-text-content-underline">{children}</span>;
    default:
      return <>{children}</>;
  }
};

const Text = ({ node }: RichTextContentProps) => {
  const { marks, value } = node;

  if (!marks || marks.length === 0) {
    return <>{value}</>;
  }

  const [firstMark, ...otherMarks] = marks;

  const nextNode = { ...node };
  nextNode.marks = otherMarks;

  return (
    <TextMark mark={firstMark}>
      <Text node={nextNode} />
    </TextMark>
  );
};

export default Text;
